import { StyleSheet } from 'react-native';
import { SEPARATOR_STROKE, MQ_TABLET, PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../../components/common/responsive-dimension-values';

var windowWidth = ResponsiveDimensionValues.windowWidth;

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    paddingVertical: 15,
  },
  logo: {
    position: 'absolute',
    right: 38,
    top: 30,
    height: 30,
    width: 30,
  },
  content: {
    flex: 1,
    paddingHorizontal: 40,
  },
  contactRow: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  login: {
    flex: 1,
  },
  username: {
    minHeight: 88,
  },
  password: {
    minHeight: 88,
  },
  label: {
    paddingTop: 10,
  },
  pushBottom: {
    paddingBottom: 15,
  },
  support: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
  },

  serverError: {
    textAlign: 'center',
    marginTop: 66,
    marginBottom: 26,
    minHeight: 32,  
    backgroundColor: PALETTE.errorColor,
    
  },

  link: {
    flex: 1,
    flexWrap: 'nowrap',
  },
  separator: {
    borderRightWidth: 1,
    borderRightColor: SEPARATOR_STROKE,
    width: 0,
    height: 16,
  },
  footer: {
    flex: 0,
    paddingHorizontal: 29,
  },
  footerLinks: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  termsTextLinks: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
  },
  footerInfo: {
    flex: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  separatorWithSpacing: {
    borderRightWidth: 1,
    borderRightColor: SEPARATOR_STROKE,
    width: 0,
    height: 16,
    marginHorizontal: 15,
  },
  changePasswordSuccess: {
    marginVertical: 30,
  },
  copyrightText: {
    textAlign: 'center',
  },
  copyrightDisclaimer: {
    textAlign: 'center',
    fontSize: 8
  },
  wrapper: {
    flex: 1
  },
  signupWrapper: {
    flex: 1,
  },
  forgotPasswordWrapper: {
    flex: 1,
  },
  termsColor: {
    color: '#E29317'
  }
}, 
{
  [MQ_TABLET]:{
    wrapper:{
      flex: 1,
      borderWidth: 1,
      padding: 20,
      borderColor:  SEPARATOR_STROKE,
      alignSelf: 'center',
      paddingLeft: 20,
      paddingRight: 20,
      width:windowWidth * 0.5,
    },
    loginButton: {
      alignSelf: 'center',
      width: windowWidth * 0.4,
      marginBottom: 20, 
    },
    loginMessage: {
      alignSelf: 'center'
    },
    copyrightText: {
      fontSize: 16,
    },
    copyrightDisclaimer: {
      fontSize: 12,
    },
    support: {
      marginTop: 7
    },
    signupWrapper: {
      flex: 1,
      borderWidth: 1,
      borderColor:  SEPARATOR_STROKE,
      alignSelf: 'center',
      paddingLeft: 20,
      paddingRight: 20,
      width:windowWidth * 0.8,
      marginBottom: 40,
    },
    forgotPasswordWrapper: {
      flex: 1,
      borderWidth: 1,
      borderColor:  SEPARATOR_STROKE,
      alignSelf: 'center',
      paddingLeft: 20,
      paddingRight: 20,
      width:windowWidth * 0.7,
      marginBottom: 40,
    }
  }
});
